var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8372 21.5233C30.2093 21.907 29.4767 21.9767 28.9186 21.6628C28.2209 21.2442 27.8023 20.3023 27.8023 19.0116V15.0698C27.8023 13.186 27.0698 11.8256 25.814 11.4767C23.686 10.8488 22.0814 13.4651 21.4884 14.4419L17.7209 20.4767V13.0465C17.686 11.3372 17.1279 10.3256 16.0814 10.0116C15.3837 9.80233 14.3372 9.90698 13.3256 11.4419L4.9186 24.907C3.80232 22.7791 3.2093 20.407 3.2093 18C3.2093 9.87209 9.73256 3.27907 17.7209 3.27907C25.7093 3.27907 32.2326 9.87209 32.2326 18V18.0349V18.0698C32.3023 19.6395 31.8139 20.8954 30.8372 21.5233ZM35.4419 18V17.9651V17.9302C35.407 8.05814 27.4535 0 17.7209 0C7.95349 0 0 8.05814 0 18C0 27.907 7.95349 36 17.7209 36C22.2209 36 26.4767 34.2907 29.7558 31.186C30.4186 30.5581 30.4535 29.5465 29.8256 28.8837C29.2326 28.2209 28.2209 28.186 27.5581 28.7791C27.5581 28.7791 27.5581 28.7791 27.5232 28.814C24.8721 31.3256 21.314 32.7558 17.6512 32.7558C13.3605 32.7558 9.52326 30.8721 6.87209 27.8721L14.4419 15.7326V21.3488C14.4419 24.0349 15.4884 24.907 16.3605 25.1512C17.2326 25.3953 18.5581 25.2209 19.9884 22.9535L24.1395 16.2209C24.2791 16.0116 24.3837 15.8023 24.5233 15.6628V19.0814C24.5233 21.593 25.5349 23.6163 27.2791 24.593C28.8488 25.5 30.8372 25.3953 32.4767 24.3837C34.5 23.0581 35.5814 20.7558 35.4419 18Z",
    fill: "#17181B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.6ac994893f29c05f36a1c64670da5954.svg";
export { ForwardRef as ReactComponent };